import styled from 'styled-components';

export const AccordionPreview = styled.p`
  ${({ theme }) => theme.typography.fontSizes.M14};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARK};
  margin: ${({ theme }) => `${theme.spacing.S4} 0 ${theme.spacing.M16}`};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PrivacyPolicyLink = styled.a`
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  text-decoration: underline;
`;
